import {
  Button,
  Divider,
  ListItem,
  ListItemIcon,
  ListItemText,
  Popover,
  styled,
} from "@mui/material";
import { useCallback, useState } from "react";
import { useCopyToClipboard } from "../../../hooks/use-copy-to-clipboard";

const ButtonShare = ({ vertical, horizontal }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpenPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = useCallback(() => {
    setAnchorEl(null);
  }, []);

  const { copy } = useCopyToClipboard();

  const recruitLink = `${window.location.origin}${window.location.pathname}${window.location.search}`;

  const shareFaceBook = () => {
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
      recruitLink
    )}`;
    const left = (window.screen.width - 700) / 2 - 300;
    const top = (window.screen.height - 500) / 2;
    window.open(
      shareUrl,
      "facebook-share-dialog",
      `width=700,height=500,left=${left},,top=${top}`
    );
    handleClose();
  };

  const shareZalo = () => {
    const shareUrl = `https://zalo.me/share/?url=${encodeURIComponent(
      recruitLink
    )}`;
    const left = (window.screen.width - 700) / 2 - 300;
    const top = (window.screen.height - 500) / 2;
    window.open(
      shareUrl,
      "zalo-share-dialog",
      `width=700,height=500,left=${left},,top=${top}`
    );
    handleClose();
  };

  const onCopyLink = () => {
    alert("Sao chép link bài viết thành công!");
    copy(recruitLink);
    handleClose();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <>
      <Button
        aria-describedby={id}
        variant="outlined"
        sx={{
          height: 44,
          position: "relative",
          borderRadius: 30,
          color: "#606060",
          borderColor: "#E2E2E2",
          px: 3,
          textTransform: "none",
          minWidth: 150,
        }}
        onClick={handleOpenPopover}
      >
        Chia sẻ
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical,
          horizontal,
        }}
        sx={{
          "& .MuiPopover-paper": {
            padding: "16px 12px !important",
            borderRadius: 2,
          },
          boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.12)",
        }}
      >
        <ListItemStyles onClick={shareFaceBook}>
          <ListItemIcon sx={{ minWidth: 36, flexShrink: 0 }}>
            <img src="/assets/icons/ic_facebook.svg" className="w-6 h-6" />
          </ListItemIcon>
          <ListItemText
            primary="Chia sẻ lên Facebook"
            primaryTypographyProps={{ typography: "body1" }}
          />
        </ListItemStyles>
        <Divider
          sx={{ width: "100%", bgcolor: "#E2E8F0", height: "1px", my: 0.5 }}
        />
        <ListItemStyles onClick={shareZalo}>
          <ListItemIcon sx={{ minWidth: 36, flexShrink: 0 }}>
            <img src="/assets/icons/ic_zalo.svg" className="w-6 h-6" />
          </ListItemIcon>
          <ListItemText
            primary="Chia sẻ lên Zalo"
            primaryTypographyProps={{ typography: "body1" }}
          />
        </ListItemStyles>
        <Divider
          sx={{ width: "100%", bgcolor: "#E2E8F0", height: "1px", my: 0.5 }}
        />
        <ListItemStyles onClick={onCopyLink}>
          <ListItemIcon sx={{ minWidth: 36, flexShrink: 0 }}>
            <img src="/assets/icons/ic_circle_link.svg" className="w-6 h-6" />
          </ListItemIcon>
          <ListItemText
            primary="Sao chép đường dẫn"
            primaryTypographyProps={{ typography: "body1" }}
          />
        </ListItemStyles>
      </Popover>
    </>
  );
};

export default ButtonShare;

const ListItemStyles = styled(ListItem)({
  padding: "8px 16px",
  "&.MuiListItem-root:hover": {
    backgroundColor: "#E6F2FA",
    color: "#037CCF",
    cursor: "pointer",
    borderRadius: "8px",
  },
});
